import StateTree from "../../globalHelpers/StateTree";
import { toast } from "react-toastify";
import PaymentUIHelper from "../../globalHelpers/PaymentUIHelper";
import { cleanUsageHistory, createYearBasedUsageList } from "./UsageHelper";
import ConnectAccountHelper from "../../globalHelpers/ConnectAccountHelper";
import CustomerHelper from "../../globalHelpers/CustomerHelper";
import { wrapContent } from "../../globalHelpers/GlobalContentWrapper";
import styleWrap from "../../globalHelpers/GlobalStyleWrapper";
import {
    getLanguage,
    setLanguage,
    subscribe,
} from "../../globalHelpers/LanguageHelper";
import LoginHelper from "../../globalHelpers/LoginHelper";
import { observables } from "../../globalHelpers/observables";
import { prettyName, formatPhone } from "../../globalHelpers/PrettyString";
import RolesHelper from "../../globalHelpers/RolesHelper";
import { isMobile, isTablet, isDesktop } from "../../globalHelpers/ViewHelper";
import LabelHelper from "./LabelHelper";

function generateGlobalCache() {
    try {
        global["idea-state-tree"] = StateTree;
        global.toast = toast;
        global.paymentUIHelper = PaymentUIHelper;
        global.UsageHelper = {
            cleanUsageHistory,
            createYearBasedUsageList,
        };
        global.ConnectAccountHelper = ConnectAccountHelper;
        global.CustomerHelper = CustomerHelper;
        global.GlobalContentWrapper = { wrapContent };
        global.GlobalStyleWrapper = { styleWrap };
        global.LanguageHelper = { getLanguage, setLanguage, subscribe };
        global.LoginHelper = LoginHelper;
        global.observables = observables;
        global.PrettyString = { prettyName, formatPhone };
        global.RolesHelper = RolesHelper;
        global.ViewHelper = { isMobile, isTablet, isDesktop };
        global.LabelHelper = LabelHelper;
    } catch (e) {
        console.log(e);
    }
}

export { generateGlobalCache };
